import React, { Component } from 'react'
import styled from 'styled-components'
import { colors, media } from '../styles/vars'
import CarouselItem from '../components/CarouselItem'
import Carousel from 'react-slick'
import "slick-carousel/slick/slick.css";
import arrowRight from '../static/images/icons/gallery_arr_r.png'
import arrowLeft from '../static/images/icons/gallery_arr_l.png'
import article1Bg from '../static/images/articles/4.jpg'
import article2Bg from '../static/images/articles/1.jpg'
import article3Bg from '../static/images/articles/5.jpg'
import article4Bg from '../static/images/articles/3.jpg'
import article5Bg from '../static/images/articles/2.jpg'
import article6Bg from '../static/images/articles/6.jpg'
import { push } from '../analytics'
import { Section } from '../styles/elements'

const Container = styled(Section) `
padding:40px 20px;
background-color:${colors.black};

${
    media.desktop`
    padding:40px;
    `
    }
`
const Title = styled.h2`
font-size:3.3rem;
line-height:.8;
color:${colors.white};
text-align:center;
&, span{
    font-weight:700;
}
span{
    color:${colors.red};
}

${
    media.desktop`
    font-size:6.2rem;
    margin-bottom:20px;
    `
    }
`
const Arrow = styled.div`
position:absolute;
top:-223px;
bottom:0;
margin:auto 0;
height:35px;
width:35px;
right:${props => props.right ? '-17px' : 'initial'};
left:${props => props.right ? 'initial' : '-17px'};
z-index:10;
cursor:pointer;

${
    media.desktop`
    top:-100px;
    right:${props => props.right ? '-120px' : 'initial'};
    left:${props => props.right ? 'initial' : '-120px'};
    `
    }
`
const CarouselContainer = styled.div`
direction:ltr;
position:relative;
${
    media.desktop`
    max-width:70%;
    margin:0 auto;
    `
    }
`
const settings = {
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
};
class CarouselSection extends Component {
    constructor() {
        super();
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
    }
    componentDidMount() {
        setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
    }
    next() {
        this.carousel.slickNext();
        push('Image Navigation', 'Right');
    }
    prev() {
        this.carousel.slickPrev();
        push('Image Navigation', 'Left');
    }
    render() {
        return (
            <Container name="oldNew">
                <div>
                    <Title>
                        הטרנטה של פעם <span>מול ההיי-טק של היום</span>
                    </Title>
                </div>
                <CarouselContainer>
                    <Arrow right onClick={this.next}>
                        <img src={arrowRight} alt="" />
                    </Arrow>
                    <Carousel {...settings} ref={node => this.carousel = node}>
                        <div>
                            <CarouselItem
                                imageSrc={article1Bg}
                                articleId="5089966"
                                title="ג'יפ סיור מול ג'יפ רנגלר: כבר לא עושים אותם ככה"
                                description={`
                                ג'יפ אמיתי בן זמננו הוא רכב נעים ובטוח, מאובזר וחזק. ג'יפ הסיור הצה"לי של פעם היה המון, חוץ מכל אלה
                                `}
                            />
                        </div>
                        <div>
                            <CarouselItem
                                imageSrc={article2Bg}
                                articleId="5096404"
                                title="רנו 4 מול דאצ'יה סנדרו סטפווי: רק היום, בזול"
                                description={`
                                משפחתית בהכי פחות כסף שאפשר. פעם היא הייתה מתוצרת צרפתית של רנו ועלתה כמעט כלום, היום היא רומנית - גם של רנו - ובמחיר נמוך במיוחד
                                `}
                            />
                        </div>
                        <div>
                            <CarouselItem
                                imageSrc={article3Bg}
                                articleId="5096446"
                                title="הינו קונטסה מול טויוטה קורולה: ישראלית במבטא יפני"
                                description={`
                                היפנית הממש ראשונה שהגיעה לישראל גם יוצרה כאן. במפתיע, גם הנינה שלה מגיעה מהמזרח התיכון ולא מארץ השמש העולה
                                `}
                            />
                        </div>
                        <div>
                            <CarouselItem
                                imageSrc={article4Bg}
                                articleId="5096487"
                                title="סובארו לאונה מול סובארו XV: כיבוש נאור"
                                description={`
                                מי לא רצה סובארו בשנות ה-80? בעיקר מי שלא הספיק להתייצב בפתח אולם התצוגה ברחוב המסגר לפנות בוקר. היום סובארו מוחזיקה בנתל שוק קטן יותר, אבל האגדות סביב הלאונה עדיין כאן
                                `}
                            />
                        </div>
                        <div>
                            <CarouselItem
                                imageSrc={article5Bg}
                                articleId="5096545"
                                title="פיז'ו 404 טנדר מול סיטרואן ברלינגו: הכולבויניקים"
                                description={`
                                סוס העבודה המוטורי-מקומי הראשון היה פיז'ו 404 בגרסת טנדר קשוחה וחסר חן. סיטרואן ברלינגו עכשווית מגיעה מאותו קונצרן ומציעה הרבה יותר עידן וסטייל - אבל ספק אם יש לה את אותו כושר השרדות
                                `}
                            />
                        </div>
                        <div>
                            <CarouselItem
                                imageSrc={article6Bg}
                                articleId="5099585"
                                title="מרצדס S280 מודל 71' מול מרצדס S560 חדשה - בחזרה לאנטבה"
                                description={`
                                מרצדס S קלאס מתחרה על התואר "הטובה בעולם" כבר המון שנים. ותתפלאו כמה זה קשור למבצע אנטבה
                                `}
                            />
                        </div>
                    </Carousel>
                    <Arrow onClick={this.prev}>
                        <img src={arrowLeft} alt="" />
                    </Arrow>
                </CarouselContainer>
            </Container>
        )
    }
}

export default CarouselSection;


// WEBPACK FOOTER //
// ./src/containers/CarouselSection.jsx